module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKElEQVR4AWMYHKB01e3/5OBBZMB/MgFyMPwnAw+8AZSHwXBIB8MDAACl4ZMqEjCoigAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BW.png
// module id = 1100
// module chunks = 0